// extracted by mini-css-extract-plugin
export default {"action":"SimpleActions_action__uL0Oq","actionHolder":"SimpleActions_actionHolder__tkx1d"};